module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fcenter2"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _vm._v("With loving memories of")]), _vm._v(" "), _c('p', {
    staticClass: "fcenter"
  }, [_vm._v("Anthony Charles ‘Tony’ Evans (ACE)")]), _vm._v(" "), _c('p', {
    staticClass: "fcenter"
  }, [_vm._v("8 October 1942 (Higher Bebington, Wirral)")]), _vm._v(" "), _c('p', {
    staticClass: "fcenter"
  }, [_vm._v("to 9 October 2018 (Christchurch, New Zealand)")]), _vm._v(" "), _c('p', {
    staticClass: "fcenter1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I have laid aside business, and gone a-fishing")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-554467ac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02_Memory.vue
// module id = 60
// module chunks = 0